import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { AlphaPicker, TwitterPicker } from "react-color";
import Switch from "./Switch";
import { equalsIgnoreCase } from "../../services/Utils";
import rgbHex from "rgb-hex";
import { COLORS } from "../WorkSpace/CanvasViewer/EncarteConstants";
import { useOutletContext } from "react-router";
export const Styles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const Style = styled.div`
  font-size: 1.4rem;

  span {
    display: block;
    margin-bottom: 0.4rem;
  }
  span::first-letter {
    text-transform: uppercase;
  }

  .icon {
    font-size: 1.4rem;
    color: black;
  }

  &.formato-style {
    justify-self: end;
  }
`;

export const Select = styled.select`
  all: unset;
  user-select: none;
  display: block;
  font-size: 1.2rem;
  background-color: #d9d9d9;
  width: 100%;
  //width: min-content;
  padding: 0.8rem 0;
  text-align: center;
  color: black;
  border: 1px solid black;
  border-radius: 5px;
  cursor: pointer;
  text-transform: capitalize;
  &:hover {
    border-color: #d07706;
    color: #d07706;
  }
  option {
    text-align: center;
    text-transform: capitalize;
    color: black !important;
  }
`;

export const ColorPicker = styled.div`
  position: relative;
  .picker {
    opacity: 0;
    transition: all 300ms ease-in-out;
    top: calc(100%) !important;
    position: absolute !important;
    cursor: pointer;
    visibility: hidden;
    z-index: 10;
  }
  .picker.show {
    opacity: 1;
    visibility: visible;
  }
`;

export const Color = styled.div`
  width: 100%;
  height: 4rem;
  border: 1px solid rgba(255, 255, 255, 0.35);
  cursor: pointer;
  border-radius: 3px;
  cursor: pointer;

  ${({ color }) => css`
    background-color: ${color};
  `}
`;

export const BgColor = styled(Color)`
  ${({ color }) => css`
    background-color: ${color};
  `}
`;

export const TxtColor = styled(Color)`
  ${({ color }) => css`
    background-color: ${color};
  `}
`;

export const Pickers = styled(Styles)`
  grid-column: 1/2;
  grid-row: 1/-1;
  align-items: center;
`;

export const FontFormatStyle = styled(Styles)`
  grid-column: 2/3;
  grid-row: 1/2;
  flex-direction: row;
`;

export const Picker = ({
  txt,
  callback,
  color,
  defaultColor = "",
  alphaPicker = false,
}) => {
  const [colors, setColors] = useState([]);

  const updateCurrentColorOnPicker = (hex) => {
    const copy = [...colors];
    copy.forEach((color, i) => {
      if (color === hex) {
        copy[i] = colors[0];
        copy[0] = hex;
      }
    });

    setColors(copy);
  };

  const safeColor = color || "rgba(52, 30, 175, 1)"; // or any default RGBA

  return (
    <Style className="flex min-gap direction-column">
      <div className="flex min-gap">
        <span>{txt}</span>
      </div>
      <ColorPicker
        onMouseOver={(e) => showPicker(e)}
        onMouseOut={(e) => hiddenPicker(e)}
        className="picker-container"
      >
        <Color
          color={color !== "" ? color : defaultColor}
          className="color-picker"
        />

        <TwitterPicker
          color={color}
          colors={COLORS}
          onChange={(c) => {
            // Extract current alpha from color (default to 1)
            let alpha = 1;
            if (safeColor.startsWith("rgba")) {
              const match = safeColor.match(/rgba?\(\d+,\d+,\d+,(.+)\)/);
              if (match) alpha = parseFloat(match[1]);
            }
            // Set color as rgba with new hue and previous alpha
            const hex = c.hex;
            callback(hexToRgba(hex, alpha));
            updateCurrentColorOnPicker(hex);
          }}
          className="picker"
        />
      </ColorPicker>
      {alphaPicker && (
        <div className="flex direction-column">
          <span>Transparência da cor de fundo</span>
          <AlphaPicker
            color={safeColor.startsWith("#") ? hexToRgba(safeColor) : safeColor}
            onChangeComplete={(c) => {
              // Clamp alpha to minimum 0.0 (0%)
              const clampedColor = {
                ...c,
                rgb: { ...c.rgb, a: Math.max(c.rgb.a, 0) },
              };
              callback(
                `rgba(${c.rgb.r},${c.rgb.g},${c.rgb.b},${clampedColor.rgb.a})`,
              );
            }}
            width="100%"
            className="picker"
            styles={{ cursor: "pointer" }}
          />
        </div>
      )}
    </Style>
  );
};

export const Selector = ({
  txt,
  callback,
  options,
  selected,
  customClassName,
  isPremiumOption = () => false,
}) => {
  const { accountStatus } = useOutletContext();
  return (
    <Style>
      <span>{txt}</span>
      <Select
        className={customClassName}
        onChange={(e) => {
          callback(e.target.value);
        }}
      >
        {options.map((op, idx) => (
          <option
            className={`op`}
            disabled={
              isPremiumOption(op, idx) && !accountStatus.isAccountPremium
            }
            selected={
              typeof selected === "String"
                ? equalsIgnoreCase(selected, op)
                  ? "selected"
                  : ""
                : selected === op
                  ? "selected"
                  : ""
            }
            value={op}
          >
            {op}
            {isPremiumOption(op, idx) && !accountStatus.isAccountPremium
              ? " (Premium)"
              : ""}
          </option>
        ))}
      </Select>
    </Style>
  );
};

const showPicker = (e) => {
  if (!e.target.closest(".picker-container")) return;
  const pi = e.target.closest(".picker-container").querySelector(".picker");
  if (!pi) return;
  pi.classList.add("show");
};

const hiddenPicker = (e) => {
  const pi = e.target.closest(".picker-container").querySelector(".picker");
  if (!pi) return;
  pi.classList.remove("show");
};

export function hexToRgba(hex, alpha = 1) {
  let c = hex.replace("#", "");

  if (c.length === 3) {
    // Handle shorthand hex (#RGB)
    c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
  } else if (c.length === 8) {
    // Extract alpha from 8-character hex (#RRGGBBAA)
    const alphaHex = c.slice(6, 8);
    alpha = parseInt(alphaHex, 16) / 255; // Convert alpha to a value between 0 and 1
    c = c.slice(0, 6); // Remove alpha part from the hex
  }
  const num = parseInt(c, 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r},${g},${b},${alpha !== null ? alpha : 1})`;
}
export function rgbaToHex(rgba, customAlpha = null) {
  // If already hex, return as is
  if (!rgba) return "#000000";
  if (typeof rgba === "string" && rgba.startsWith("#")) return rgba;

  // Extract numbers from rgba/rgb string
  const match = rgba.match(/\d+(\.\d+)?/g);
  if (!match) return "#000000";

  let [r, g, b, a] = match.map(Number);

  // If a custom alpha is provided, use it
  if (
    customAlpha !== null &&
    typeof customAlpha === "number" &&
    customAlpha >= 0 &&
    customAlpha <= 1
  ) {
    a = customAlpha;
  } else if (a === undefined) {
    // If original string was RGB, set alpha to 1 (fully opaque)
    a = 1;
  }

  // rgb-hex expects r, g, b, [a]
  return "#" + rgbHex(r, g, b, a);
}
